import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import { loadFonts } from './plugins/webfontloader'
import axios from 'axios';
const config = require("./Utils/config.json");

axios.defaults.baseURL = config.baseURL || 'http://localhost:3000/api/' 
loadFonts()

createApp(App).use(router)
  .use(vuetify)
  .mount('#app')
